import { createLink } from '#imports'
import type { LinkSchema } from '@core/types'

export const useLinks = () => {
    const { t } = useI18n()

    const frontpage = createLink(() => {
        return {
            to: { path: '/' } as LinkSchema['to'],
        }
    })

    const signup = createLink(() => {
        return {
            to: {
                query: {
                    auth: 'signup',
                    step: '1',
                },
            },
        }
    })

    const login = createLink(() => {
        return {
            to: {
                query: {
                    auth: 'login',
                },
            },
        }
    })

    const forgotPassword = createLink(() => {
        return {
            to: {
                query: {
                    auth: 'forgot-password',
                },
            },
        }
    })

    const payments = createLink(() => {
        return {
            to: { path: t('pages.deposit') } as LinkSchema['to'],
            external: true,
        }
    })

    const support = createLink(() => {
        return {
            to: {
                name: 'support',
            },
        }
    })

    return {
        frontpage,
        signup,
        login,
        forgotPassword,
        payments,
        support,
    }
}
